export default "__VITE_ASSET__hsvehmFQ__"